export const OFFLINE_ACTION_QUEUE_KEY = 'offline_action_queue';

export const readOfflineActionQueue = () => {
  try {
    const raw = localStorage.getItem(OFFLINE_ACTION_QUEUE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (_err) {
    return [];
  }
};

export const areOfflineQueuesEqual = (a, b) => {
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i += 1) {
    if (JSON.stringify(a[i]) !== JSON.stringify(b[i])) return false;
  }
  return true;
};

export const getOfflineActionLabel = (type) => {
  if (type === 'order_create') return 'Create order';
  if (type === 'transaction_create') return 'Add transaction';
  if (type === 'product_create') return 'Create product';
  if (type === 'order_note_update') return 'Update order notes';
  if (type === 'product_note_update') return 'Update product notes';
  return 'Queued action';
};

export const getOfflineActionMeta = (entry) => {
  if (!entry?.payload || typeof entry.payload !== 'object') return '';
  if (entry.type === 'order_create') {
    const number = entry.payload.order_number ? `#${entry.payload.order_number}` : '';
    const buyer = entry.payload.buyer_name ? `Buyer: ${entry.payload.buyer_name}` : '';
    return [number, buyer].filter(Boolean).join(' | ');
  }
  if (entry.type === 'transaction_create') {
    const material = entry.payload.custom_fields?.raw_material_type || '';
    const qty = entry.payload.quantity !== undefined ? `Qty: ${entry.payload.quantity}` : '';
    return [material, qty].filter(Boolean).join(' | ');
  }
  if (entry.type === 'product_create') {
    return entry.payload.name ? `Product: ${entry.payload.name}` : '';
  }
  if (entry.type === 'order_note_update' || entry.type === 'product_note_update') {
    return entry.payload.id ? `ID: ${entry.payload.id}` : '';
  }
  return '';
};
